import CrudPage from "@/components/CrudPage";
import { useAuth } from "@/contexts/AuthContext";

export default function Operators() {
  const { user } = useAuth();
  const canWrite = ["Owner", "ProductionManager"].includes(user?.role);
  return (
    <CrudPage
      eyebrow="Master data"
      title="Operators"
      description="Roastery floor operators (separate from app users — for labour & traceability)."
      testIdPrefix="operators"
      resource="operators"
      canWrite={canWrite}
      emptyHint="Add the people who run the roasters day-to-day."
      columns={[
        { key: "name", label: "First name" },
        { key: "surname", label: "Surname" },
        { key: "employee_code", label: "Employee #" },
      ]}
      fields={[
        { key: "name", label: "First name", required: true },
        { key: "surname", label: "Surname" },
        { key: "employee_code", label: "Employee code" },
      ]}
    />
  );
}
